import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { RewardsWalletQuery, RewardsWalletService, ScreenType, WalletGroupItem } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';

import gsap from 'gsap';
import Draggable from 'gsap/Draggable';

@Component({
  selector: 'fgb-wallet-page',
  templateUrl: './wallet-page.component.html',
  styleUrls: ['./wallet-page.component.scss'],
})
export class WalletPageComponent implements OnInit, AfterViewInit {
  walletItems$: Observable<WalletGroupItem[]>;
  showCampaignOfferList: boolean = false;
  screenType = ScreenType;

  @ViewChild('walletContainer', { static: false }) walletContainerRef: ElementRef;
  @ViewChild('walletHeader', { read: ElementRef }) walletHeaderRef: ElementRef<HTMLElement>;
  private draggableInstance: any;

  constructor(
    private rewardsWalletQuery: RewardsWalletQuery,
    private rewardsWalletService: RewardsWalletService
  ) {
    gsap.registerPlugin(Draggable);
  }

  async ngOnInit() {
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
    this.walletItems$ = this.rewardsWalletQuery.selectGroupedUnredeemedWalletItems();
  }

  ngAfterViewInit() {
    if (this.walletContainerRef) {
      this.initiateDraggable();
    }
  }

  initiateDraggable() {
    const walletContainerElement = this.walletContainerRef.nativeElement.closest('fgb-wallet-page') as HTMLElement;
    const walletContainerHeight = walletContainerElement.clientHeight;
    const measureDragDistance = () => {
      const sheet = this.walletContainerRef.nativeElement as HTMLElement;
      const currentY = Number(gsap.getProperty(sheet, 'y')) || 0;
      const header = this.walletHeaderRef.nativeElement.querySelector<HTMLElement>('.page-header');
      if (!header) return 0;
      // Measure the untransformed sheet position so it stops below the header.
      return Math.max(0, sheet.getBoundingClientRect().top - currentY - header.getBoundingClientRect().bottom);
    };
    let barcodeHeight = measureDragDistance();
    this.draggableInstance = Draggable.create(this.walletContainerRef.nativeElement, {
      type: 'y',
      edgeResistance: 1,
      bounds: { minY: -barcodeHeight, maxY: 0 },
      inertia: true,
      handle: '.grab-point',
      onPress: () => {
        gsap.killTweensOf(this.walletContainerRef.nativeElement);
        // Card data loads asynchronously; use the current layout for every drag.
        barcodeHeight = measureDragDistance();
        this.draggableInstance.applyBounds({ minY: -barcodeHeight, maxY: 0 });
      },
      onDrag: () => {
        const y = this.draggableInstance.y;
        walletContainerElement.style.height = `${walletContainerHeight + barcodeHeight + y}px`;
      },
      onDragEnd: () => {
        const y = this.draggableInstance.y;
        let snapY = 0;
        // Snap to nearest
        snapY = Math.abs(y + barcodeHeight) < Math.abs(y) ? -barcodeHeight : 0;
        gsap.to(this.walletContainerRef.nativeElement, {
          y: snapY,
          duration: 0.3,
          onUpdate: () => {
            const currentY = gsap.getProperty(this.walletContainerRef.nativeElement, 'y') as number;
            walletContainerElement.style.height = `${walletContainerHeight + barcodeHeight + currentY}px`;
          },
        });
      },
    })[0];
  }
  ngOnDestroy() {
    if (this.draggableInstance) {
      this.draggableInstance.kill();
    }
  }
}
